var Ribbon_default = {
  "ribbon": "_7744-",
  "ribbonText": "RaN3x",
  "imageRibbon": "_4bKad"
};
export {
  Ribbon_default as default
};
//# sourceMappingURL=Ribbon-scss.js.map
